import React from 'react'

import { Label } from 'semantic-ui-react'

import './InfoLabel.scss'

const InfoLabel = (props) => {
    return (
        <Label basic color='green' size='large' className='cb-info-label'>
            {props.children}
        </Label>
    )
}

export default InfoLabel